(function () {
  'use strict';

  try {
    var _debugParams = new URLSearchParams(window.location.search);
    if (_debugParams.get('zug_debug_acrylic') === '1') {
      document.documentElement.classList.add('zug-debug-acrylic');
    }
    if (_debugParams.get('zug_debug_hw') === '1') {
      document.documentElement.classList.add('zug-debug-hw');
    }
  } catch (_e) {}

  var LAYER_ORDER = ['thickness', 'plate', 'bgFill', 'printBorder', 'print', 'rim', 'frost', 'gloss', 'shine', 'outline', 'debug'];
  var PRINT_REGION_LAYERS = ['bgFill', 'printBorder', 'print'];
  var _container = null;
  var _stack = null;
  var _layers = {};
  var _active = false;
  var _currentOpts = {};
  var _hasTab = false;
  var _printRegion = null;
  var _hardwareEl = null;
  var _isKeychain = false;
  var _sourceCache = {};
  var _renderToken = 0;
  var SOURCE_CANVAS_SIZE = 800;
  var ALPHA_THRESHOLD = 10;
  var ASPECT_RATIO_TOLERANCE = 0.02;

  function _selectSourceCandidates(sources) {
    sources = sources || {};
    function exteriorComposite(url, pixelSource) {
      if (!url || !sources.foreground) return null;
      return {
        url: url,
        boundsUrl: sources.foreground,
        kind: 'dcf-exterior-composite',
        pixelSource: pixelSource,
        aligned: false,
        padded: true,
        trustworthy: true,
        preservesInterior: true,
        reason: pixelSource + ' print pixels cropped by DCF exterior-foreground bounds and clipped by the DCF body contour'
      };
    }
    function originalCandidate(url, pixelSource) {
      if (!url) return null;
      return {
        url: url,
        kind: 'original-upload',
        pixelSource: pixelSource,
        aligned: false,
        padded: false,
        trustworthy: true,
        preservesInterior: true,
        reason: pixelSource + '; native alpha/content bounds are mapped to the DCF body contour'
      };
    }
    function uniqueCandidates(candidates) {
      var seenUrls = {};
      return candidates.filter(function (candidate) {
        if (!candidate || seenUrls[candidate.url]) return false;
        seenUrls[candidate.url] = true;
        return true;
      });
    }

    var exteriorComposites = uniqueCandidates([
      exteriorComposite(sources.localOriginal, 'local original upload'),
      exteriorComposite(sources.original, 'DCF original asset')
    ]);
    var originals = uniqueCandidates([
      originalCandidate(sources.localOriginal, 'local original upload'),
      originalCandidate(sources.original, 'DCF original asset')
    ]);
    var artworkCanvas = {
      url: sources.artworkCanvas || null,
      kind: 'dcf-artwork-canvas',
      pixelSource: 'DCF artwork canvas',
      aligned: true,
      padded: false,
      trustworthy: true,
      preservesInterior: false,
      reason: 'normalized transparent DCF artwork aligned to the cutline coordinate system'
    };
    var artwork = {
      url: sources.artwork || null,
      kind: 'artwork-png',
      pixelSource: 'DCF printable artwork',
      aligned: false,
      padded: true,
      trustworthy: true,
      preservesInterior: false,
      reason: 'DCF printable artwork; alpha bounds must be mapped to the body contour'
    };
    var foreground = {
      url: sources.foreground || null,
      kind: 'dcf-foreground',
      pixelSource: 'DCF foreground',
      aligned: false,
      padded: true,
      trustworthy: false,
      preservesInterior: false,
      reason: 'DCF global foreground may lose distressed or edge-connected interior colors'
    };
    var preview = {
      url: sources.preview || null,
      kind: 'preview-png-fallback',
      pixelSource: 'DCF preview composite',
      aligned: false,
      padded: true,
      trustworthy: false,
      preservesInterior: false,
      reason: 'last-resort DCF presentation composite; may contain baked preview pixels'
    };

    if (sources.requireExteriorOnly) {
      return exteriorComposites;
    }

    var ordered = sources.hasNativeTransparency || sources.preferOriginal
      ? originals.concat([artworkCanvas, artwork, foreground, preview])
      : [artworkCanvas, artwork].concat(originals, [foreground, preview]);
    return ordered.filter(function (candidate) { return !!candidate.url; });
  }

  function _projectAlphaBounds(alphaBounds, fromWidth, fromHeight, toWidth, toHeight) {
    if (!alphaBounds || !fromWidth || !fromHeight || !toWidth || !toHeight) return null;
    var fromAspect = fromWidth / fromHeight;
    var toAspect = toWidth / toHeight;
    var aspectDrift = Math.abs(fromAspect - toAspect) / Math.max(fromAspect, toAspect);
    if (!isFinite(aspectDrift) || aspectDrift > ASPECT_RATIO_TOLERANCE) return null;
    var scaleX = toWidth / fromWidth;
    var scaleY = toHeight / fromHeight;
    var x = alphaBounds.x * scaleX;
    var y = alphaBounds.y * scaleY;
    var width = alphaBounds.width * scaleX;
    var height = alphaBounds.height * scaleY;
    return {
      x: x,
      y: y,
      width: width,
      height: height,
      padding: {
        left: x,
        right: Math.max(0, toWidth - x - width),
        top: y,
        bottom: Math.max(0, toHeight - y - height)
      },
      canvasWidth: toWidth,
      canvasHeight: toHeight,
      transparentPixels: alphaBounds.transparentPixels,
      hasTransparency: alphaBounds.hasTransparency,
      boundsCanvasWidth: fromWidth,
      boundsCanvasHeight: fromHeight,
      boundsScaleX: scaleX,
      boundsScaleY: scaleY
    };
  }

  function _alphaBoundsFromPixels(data, width, height, threshold) {
    var minX = width;
    var minY = height;
    var maxX = -1;
    var maxY = -1;
    var transparentPixels = 0;
    var alphaThreshold = threshold == null ? ALPHA_THRESHOLD : threshold;
    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        var alpha = data[(y * width + x) * 4 + 3];
        if (alpha > alphaThreshold) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        } else {
          transparentPixels++;
        }
      }
    }
    if (maxX < minX || maxY < minY) return null;
    var alphaW = maxX - minX + 1;
    var alphaH = maxY - minY + 1;
    return {
      x: minX,
      y: minY,
      width: alphaW,
      height: alphaH,
      padding: {
        left: minX,
        right: width - maxX - 1,
        top: minY,
        bottom: height - maxY - 1
      },
      canvasWidth: width,
      canvasHeight: height,
      transparentPixels: transparentPixels,
      hasTransparency: transparentPixels > 0
    };
  }

  function _mappedContentBounds(alphaBounds, targetBounds) {
    if (!alphaBounds || !targetBounds || alphaBounds.width <= 0 || alphaBounds.height <= 0) return null;
    var scale = Math.min(
      targetBounds.width / alphaBounds.width,
      targetBounds.height / alphaBounds.height
    );
    var width = alphaBounds.width * scale;
    var height = alphaBounds.height * scale;
    return {
      x: targetBounds.x + (targetBounds.width - width) / 2,
      y: targetBounds.y + (targetBounds.height - height) / 2,
      width: width,
      height: height,
      scale: scale,
      offsetX: targetBounds.x + (targetBounds.width - width) / 2,
      offsetY: targetBounds.y + (targetBounds.height - height) / 2
    };
  }

  function _exteriorCompositeBleed(alphaBounds, mappedBounds, printBounds) {
    if (!alphaBounds || !mappedBounds || !printBounds) return null;
    var scale = mappedBounds.scale ||
      Math.min(mappedBounds.width / alphaBounds.width, mappedBounds.height / alphaBounds.height);
    var canvasWidth = alphaBounds.canvasWidth;
    var canvasHeight = alphaBounds.canvasHeight;
    if (
      !isFinite(scale) || scale <= 0 ||
      !isFinite(canvasWidth) || canvasWidth <= 0 ||
      !isFinite(canvasHeight) || canvasHeight <= 0
    ) {
      return null;
    }

    var requiredLeft = Math.max(0, mappedBounds.x - printBounds.x) / scale;
    var requiredTop = Math.max(0, mappedBounds.y - printBounds.y) / scale;
    var requiredRight = Math.max(
      0,
      printBounds.x + printBounds.width - (mappedBounds.x + mappedBounds.width)
    ) / scale;
    var requiredBottom = Math.max(
      0,
      printBounds.y + printBounds.height - (mappedBounds.y + mappedBounds.height)
    ) / scale;

    var sourceX = Math.max(0, alphaBounds.x - requiredLeft);
    var sourceY = Math.max(0, alphaBounds.y - requiredTop);
    var sourceRight = Math.min(
      canvasWidth,
      alphaBounds.x + alphaBounds.width + requiredRight
    );
    var sourceBottom = Math.min(
      canvasHeight,
      alphaBounds.y + alphaBounds.height + requiredBottom
    );
    var sourceBounds = {
      x: sourceX,
      y: sourceY,
      width: sourceRight - sourceX,
      height: sourceBottom - sourceY
    };
    var drawBounds = {
      x: mappedBounds.x - (alphaBounds.x - sourceX) * scale,
      y: mappedBounds.y - (alphaBounds.y - sourceY) * scale,
      width: sourceBounds.width * scale,
      height: sourceBounds.height * scale
    };
    var epsilon = 0.05;
    var complete =
      drawBounds.x <= printBounds.x + epsilon &&
      drawBounds.y <= printBounds.y + epsilon &&
      drawBounds.x + drawBounds.width >= printBounds.x + printBounds.width - epsilon &&
      drawBounds.y + drawBounds.height >= printBounds.y + printBounds.height - epsilon;

    return {
      sourceBounds: sourceBounds,
      drawBounds: drawBounds,
      scale: scale,
      complete: complete
    };
  }

  function _cacheKey(candidate, targetBounds, printBounds) {
    return [
      candidate.kind,
      candidate.url,
      candidate.boundsUrl || '',
      targetBounds ? targetBounds.x : 0,
      targetBounds ? targetBounds.y : 0,
      targetBounds ? targetBounds.width : SOURCE_CANVAS_SIZE,
      targetBounds ? targetBounds.height : SOURCE_CANVAS_SIZE,
      printBounds ? printBounds.x : 0,
      printBounds ? printBounds.y : 0,
      printBounds ? printBounds.width : SOURCE_CANVAS_SIZE,
      printBounds ? printBounds.height : SOURCE_CANVAS_SIZE
    ].join('|');
  }

  function _prepareSource(candidate, geoResult, callback) {
    var targetBounds = geoResult && geoResult.bbox
      ? geoResult.bbox
      : { x: 0, y: 0, width: SOURCE_CANVAS_SIZE, height: SOURCE_CANVAS_SIZE };
    var printBounds = geoResult && geoResult.printBbox ? geoResult.printBbox : targetBounds;
    var key = _cacheKey(candidate, targetBounds, printBounds);
    if (_sourceCache[key]) {
      callback(null, _sourceCache[key]);
      return;
    }

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var width = probe.naturalWidth;
      var height = probe.naturalHeight;
      if (!width || !height) {
        callback(new Error('decoded image has zero dimensions'));
        return;
      }

      function prepareWithBoundsProbe(boundsProbe) {
        var sourceCanvas = document.createElement('canvas');
        var boundsWidth = boundsProbe.naturalWidth;
        var boundsHeight = boundsProbe.naturalHeight;
        sourceCanvas.width = boundsWidth;
        sourceCanvas.height = boundsHeight;
        var sourceContext = sourceCanvas.getContext('2d');
        var alphaBounds = null;
        try {
          sourceContext.drawImage(boundsProbe, 0, 0);
          alphaBounds = _alphaBoundsFromPixels(
            sourceContext.getImageData(0, 0, boundsWidth, boundsHeight).data,
            boundsWidth,
            boundsHeight,
            ALPHA_THRESHOLD
          );
        } catch (readError) {
          callback(new Error('cannot inspect source alpha bounds: ' + readError.message));
          return;
        }

        if (!alphaBounds) {
          callback(new Error('source contains no printable pixels'));
          return;
        }

        if (boundsWidth !== width || boundsHeight !== height) {
          alphaBounds = _projectAlphaBounds(alphaBounds, boundsWidth, boundsHeight, width, height);
          if (!alphaBounds) {
            callback(new Error('DCF foreground and original artwork use incompatible aspect ratios'));
            return;
          }
        }

        var isAlignedCanvas = candidate.aligned &&
          width === SOURCE_CANVAS_SIZE &&
          height === SOURCE_CANVAS_SIZE &&
          alphaBounds.hasTransparency;
        if (candidate.aligned && !isAlignedCanvas) {
          callback(new Error('aligned artwork canvas must be transparent and exactly 800x800'));
          return;
        }
        var mappedBounds = isAlignedCanvas
          ? (alphaBounds || { x: 0, y: 0, width: width, height: height })
          : _mappedContentBounds(alphaBounds, targetBounds);
        var sourceDrawBounds = alphaBounds;
        var mappedDrawBounds = mappedBounds;
        var exteriorBleed = null;
        if (!isAlignedCanvas && candidate.kind === 'dcf-exterior-composite') {
          exteriorBleed = _exteriorCompositeBleed(alphaBounds, mappedBounds, printBounds);
          if (exteriorBleed) {
            sourceDrawBounds = exteriorBleed.sourceBounds;
            mappedDrawBounds = exteriorBleed.drawBounds;
          }
        }
        var diagnostics = {
          kind: candidate.kind,
          pixelSource: candidate.pixelSource || candidate.kind,
          selectionReason: candidate.reason,
          trustworthy: candidate.trustworthy,
          preservesInterior: candidate.preservesInterior,
          padded: candidate.padded,
          aligned: isAlignedCanvas,
          canvasWidth: width,
          canvasHeight: height,
          boundsCanvasWidth: alphaBounds.boundsCanvasWidth || boundsWidth,
          boundsCanvasHeight: alphaBounds.boundsCanvasHeight || boundsHeight,
          boundsScaleX: alphaBounds.boundsScaleX || 1,
          boundsScaleY: alphaBounds.boundsScaleY || 1,
          alphaBounds: alphaBounds,
          alphaBoundsSource: candidate.boundsUrl ? 'dcf-foreground' : candidate.kind,
          mappedBounds: mappedBounds,
          sourceDrawBounds: sourceDrawBounds,
          mappedDrawBounds: mappedDrawBounds,
          printCoverageComplete: exteriorBleed ? exteriorBleed.complete : null,
          printBounds: geoResult ? geoResult.printBbox : null,
          outerBounds: geoResult ? (geoResult.cutBbox || geoResult.outerBbox) : null,
          targetBounds: targetBounds,
          uniformScale: isAlignedCanvas ? 1 : (mappedBounds ? mappedBounds.scale : null),
          offsetX: isAlignedCanvas ? 0 : (mappedBounds ? mappedBounds.offsetX : null),
          offsetY: isAlignedCanvas ? 0 : (mappedBounds ? mappedBounds.offsetY : null)
        };

        if (isAlignedCanvas) {
          var directResult = { url: candidate.url, owned: false, diagnostics: diagnostics };
          _sourceCache[key] = directResult;
          callback(null, directResult);
          return;
        }

        var mappedCanvas = document.createElement('canvas');
        mappedCanvas.width = SOURCE_CANVAS_SIZE;
        mappedCanvas.height = SOURCE_CANVAS_SIZE;
        var mappedContext = mappedCanvas.getContext('2d');
        mappedContext.drawImage(
          probe,
          sourceDrawBounds.x,
          sourceDrawBounds.y,
          sourceDrawBounds.width,
          sourceDrawBounds.height,
          mappedDrawBounds.x,
          mappedDrawBounds.y,
          mappedDrawBounds.width,
          mappedDrawBounds.height
        );
        mappedCanvas.toBlob(function (blob) {
          if (!blob) {
            callback(new Error('mapped artwork canvas could not be encoded'));
            return;
          }
          var blobUrl = URL.createObjectURL(blob);
          var mappedResult = { url: blobUrl, owned: true, diagnostics: diagnostics };
          _sourceCache[key] = mappedResult;
          callback(null, mappedResult);
        }, 'image/png');
      }

      if (candidate.boundsUrl && candidate.boundsUrl !== candidate.url) {
        var boundsProbe = new Image();
        boundsProbe.crossOrigin = 'anonymous';
        boundsProbe.onload = function () {
          prepareWithBoundsProbe(boundsProbe);
        };
        boundsProbe.onerror = function () {
          callback(new Error('DCF exterior-foreground bounds failed to load'));
        };
        boundsProbe.src = candidate.boundsUrl;
      } else {
        prepareWithBoundsProbe(probe);
      }
    };
    probe.onerror = function () {
      callback(new Error('source image failed to load'));
    };
    probe.src = candidate.url;
  }

  function _formatBounds(bounds) {
    if (!bounds) return 'n/a';
    return [
      Number(bounds.x).toFixed(1),
      Number(bounds.y).toFixed(1),
      Number(bounds.width).toFixed(1),
      Number(bounds.height).toFixed(1)
    ].join(',');
  }

  function _renderSourceDiagnostics(geoResult, diagnostics) {
    if (!_stack || !diagnostics) return;
    _stack.dataset.acrylicSourceKind = diagnostics.kind;
    _stack.dataset.acrylicSourceAligned = diagnostics.aligned ? 'true' : 'false';
    _stack.dataset.acrylicSourcePadded = diagnostics.padded ? 'true' : 'false';
    _stack.dataset.acrylicSourceTrustworthy = diagnostics.trustworthy ? 'true' : 'false';
    _stack.dataset.acrylicSourcePreservesInterior = diagnostics.preservesInterior ? 'true' : 'false';
    _stack.dataset.acrylicAlphaBoundsSource = diagnostics.alphaBoundsSource || diagnostics.kind;
    _stack.dataset.acrylicPixelSource = diagnostics.pixelSource || diagnostics.kind;

    var sourceLabel = _stack.querySelector('.zug-acrylic-src-label');
    if (sourceLabel) {
      var padding = diagnostics.alphaBounds && diagnostics.alphaBounds.padding;
      var paddingText = padding
        ? [padding.left, padding.right, padding.top, padding.bottom].join('/')
        : 'n/a';
      sourceLabel.textContent = [
        'SRC: ' + diagnostics.kind + (diagnostics.padded ? ' (⚠ padded)' : ' ✓ aligned'),
        'canvas: ' + diagnostics.canvasWidth + '×' + diagnostics.canvasHeight,
        'pixel source: ' + (diagnostics.pixelSource || diagnostics.kind),
        'bounds canvas: ' + diagnostics.boundsCanvasWidth + '×' + diagnostics.boundsCanvasHeight,
        'bounds scale x/y: ' + Number(diagnostics.boundsScaleX || 1).toFixed(5) + '/' +
          Number(diagnostics.boundsScaleY || 1).toFixed(5),
        'alpha source: ' + (diagnostics.alphaBoundsSource || diagnostics.kind),
        'alpha x,y,w,h: ' + _formatBounds(diagnostics.alphaBounds),
        'padding L/R/T/B: ' + paddingText,
        'mapped x,y,w,h: ' + _formatBounds(diagnostics.mappedBounds),
        'source draw x,y,w,h: ' + _formatBounds(diagnostics.sourceDrawBounds),
        'mapped draw x,y,w,h: ' + _formatBounds(diagnostics.mappedDrawBounds),
        'print coverage: ' + (
          diagnostics.printCoverageComplete == null
            ? 'n/a'
            : (diagnostics.printCoverageComplete ? 'complete' : 'source-edge limited')
        ),
        'print x,y,w,h: ' + _formatBounds(diagnostics.printBounds),
        'outer x,y,w,h: ' + _formatBounds(diagnostics.outerBounds),
        'scale: ' + (diagnostics.uniformScale == null ? 'n/a' : Number(diagnostics.uniformScale).toFixed(5)),
        'offset x/y: ' + (diagnostics.offsetX == null ? 'n/a' : Number(diagnostics.offsetX).toFixed(2)) + '/' +
          (diagnostics.offsetY == null ? 'n/a' : Number(diagnostics.offsetY).toFixed(2))
      ].join('\n');
    }

    var debugLayer = _layers.debug;
    if (!debugLayer) return;
    var viewBox = geoResult && geoResult.expandedViewBox
      ? geoResult.expandedViewBox
      : { x: 0, y: 0, width: SOURCE_CANVAS_SIZE, height: SOURCE_CANVAS_SIZE };
    var alpha = diagnostics.alphaBounds;
    var mapped = diagnostics.mappedBounds;
    var mappedDraw = diagnostics.mappedDrawBounds;
    var print = diagnostics.printBounds;
    var outer = diagnostics.outerBounds;
    var overlay =
      '<svg class="zug-acrylic-source-debug-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="' +
      [viewBox.x, viewBox.y, viewBox.width, viewBox.height].join(' ') +
      '" style="position:absolute;inset:0;width:100%;height:100%;display:block;overflow:visible;">' +
      '<rect x="0" y="0" width="' + SOURCE_CANVAS_SIZE + '" height="' + SOURCE_CANVAS_SIZE +
      '" fill="none" stroke="#ff9f1c" stroke-width="2" stroke-dasharray="10,5" opacity="0.9"/>' +
      (alpha
        ? '<rect x="' + alpha.x + '" y="' + alpha.y + '" width="' + alpha.width + '" height="' + alpha.height +
          '" fill="none" stroke="#ff2bd6" stroke-width="2" stroke-dasharray="7,4" opacity="0.95"/>'
        : '') +
      (mapped
        ? '<rect x="' + mapped.x + '" y="' + mapped.y + '" width="' + mapped.width + '" height="' + mapped.height +
          '" fill="none" stroke="#00e5ff" stroke-width="2" stroke-dasharray="5,3" opacity="0.95"/>'
        : '') +
      (mappedDraw
        ? '<rect x="' + mappedDraw.x + '" y="' + mappedDraw.y + '" width="' + mappedDraw.width + '" height="' + mappedDraw.height +
          '" fill="none" stroke="#f5ff39" stroke-width="2" stroke-dasharray="3,2" opacity="0.95"/>'
        : '') +
      (print
        ? '<rect x="' + print.x + '" y="' + print.y + '" width="' + print.width + '" height="' + print.height +
          '" fill="none" stroke="#39ff14" stroke-width="2" opacity="0.8"/>'
        : '') +
      (outer
        ? '<rect x="' + outer.x + '" y="' + outer.y + '" width="' + outer.width + '" height="' + outer.height +
          '" fill="none" stroke="#2389ff" stroke-width="2" opacity="0.8"/>'
        : '') +
      '</svg>';
    var oldOverlay = debugLayer.querySelector('.zug-acrylic-source-debug-overlay');
    if (oldOverlay && oldOverlay.parentNode) oldOverlay.parentNode.removeChild(oldOverlay);
    debugLayer.insertAdjacentHTML('beforeend', overlay);
  }

  window.ZugAcrylicSourceMapping = {
    selectCandidates: _selectSourceCandidates,
    alphaBoundsFromPixels: _alphaBoundsFromPixels,
    projectAlphaBounds: _projectAlphaBounds,
    mappedContentBounds: _mappedContentBounds,
    exteriorCompositeBleed: _exteriorCompositeBleed
  };

  function _makeLayerDiv(name) {
    var div = document.createElement('div');
    div.className = 'zug-acrylic-layer zug-acrylic-layer--' + name;
    div.dataset.acrLayer = name;
    return div;
  }

  function _buildStack(container) {
    _stack = document.createElement('div');
    _stack.className = 'zug-acrylic-layer-stack';
    LAYER_ORDER.forEach(function (name) {
      var layer = _makeLayerDiv(name);
      _layers[name] = layer;
      _stack.appendChild(layer);
    });
    container.appendChild(_stack);
  }

  function _removeHardware() {
    if (_hardwareEl && _hardwareEl.parentNode) {
      _hardwareEl.parentNode.removeChild(_hardwareEl);
    }
    _hardwareEl = null;
  }

  function _ensurePrintRegion() {
    if (_printRegion) return _printRegion;
    _printRegion = document.createElement('div');
    _printRegion.className = 'zug-acrylic-print-region';
    PRINT_REGION_LAYERS.forEach(function (name) {
      if (_layers[name]) {
        _printRegion.appendChild(_layers[name]);
      }
    });
    var rimLayer = _layers.rim;
    if (rimLayer) {
      _stack.insertBefore(_printRegion, rimLayer);
    } else {
      _stack.appendChild(_printRegion);
    }
    return _printRegion;
  }

  function _removePrintRegion() {
    if (!_printRegion) return;
    var rimLayer = _layers.rim;
    PRINT_REGION_LAYERS.forEach(function (name) {
      if (_layers[name] && _layers[name].parentNode === _printRegion) {
        if (rimLayer) {
          _stack.insertBefore(_layers[name], rimLayer);
        } else {
          _stack.appendChild(_layers[name]);
        }
      }
    });
    if (_printRegion.parentNode) {
      _printRegion.parentNode.removeChild(_printRegion);
    }
    _printRegion = null;
  }

  function _applyHardware(hwConfig, holeAnchor, geoData) {
    if (!_stack || !hwConfig || !hwConfig.assetUrl) return;
    _removeHardware();

    if (!holeAnchor) {
      console.log('[ZUG][HW] no holeAnchor — skipping hardware');
      return;
    }

    _hardwareEl = document.createElement('div');
    _hardwareEl.className = 'zug-acrylic-hardware';

    var img = document.createElement('img');
    img.src = hwConfig.assetUrl;
    img.alt = 'Keychain hardware';
    img.draggable = false;
    _hardwareEl.appendChild(img);

    var holeXPct = holeAnchor.xPct;
    var holeYPct = holeAnchor.yPct;

    var hwAnchorX = hwConfig.hardwareAnchorXPct != null ? hwConfig.hardwareAnchorXPct : 0.50;
    var hwAnchorY = hwConfig.hardwareAnchorYPct != null ? hwConfig.hardwareAnchorYPct : 0.70;

    var ringDiameterIn = hwConfig.ringDiameterIn || 1.0;
    var hwWidthPct;
    if (geoData && geoData.bodyBboxWidth > 0 && geoData.physW > 0 && geoData.evbWidth > 0) {
      var realVBPerInch = geoData.bodyBboxWidth / geoData.physW;
      var evbWidthPhysical = geoData.evbWidth / realVBPerInch;
      hwWidthPct = (ringDiameterIn / evbWidthPhysical) * 100;
      console.log('[ZUG][HW] === PROPORTIONAL SIZING (unchanged) ===');
      console.log('[ZUG][HW]   ringDiameterIn=' + ringDiameterIn + ' evbWidthPhysical=' + evbWidthPhysical.toFixed(3) + '" → hwWidthPct=' + hwWidthPct.toFixed(2) + '%');
    } else if (hwConfig.legacyWidthPct) {
      hwWidthPct = hwConfig.legacyWidthPct;
    } else {
      hwWidthPct = 36;
    }

    _stack.style.setProperty('--acr-hw-x', holeXPct.toFixed(4) + '%');
    _stack.style.setProperty('--acr-hw-y', holeYPct.toFixed(4) + '%');
    _stack.style.setProperty('--acr-hw-width', hwWidthPct.toFixed(4) + '%');
    _stack.style.setProperty('--acr-hw-anchor-x', (hwAnchorX * 100).toFixed(2) + '%');
    _stack.style.setProperty('--acr-hw-anchor-y', (hwAnchorY * 100).toFixed(2) + '%');

    _stack.appendChild(_hardwareEl);

    console.log('[ZUG][HW] === POSITION DEBUG ===');
    console.log('[ZUG][HW]   acrylic holeAnchor: x=' + holeXPct.toFixed(2) + '% y=' + holeYPct.toFixed(2) + '%');
    console.log('[ZUG][HW]   hardwareAnchor inside PNG: x=' + (hwAnchorX * 100).toFixed(1) + '% y=' + (hwAnchorY * 100).toFixed(1) + '%');
    console.log('[ZUG][HW]   hwWidthPct=' + hwWidthPct.toFixed(2) + '%');
    console.log('[ZUG][HW]   CSS transform: translateX(-' + (hwAnchorX * 100).toFixed(1) + '%) translateY(-' + (hwAnchorY * 100).toFixed(1) + '%)');

    img.addEventListener('load', function onHwLoad() {
      img.removeEventListener('load', onHwLoad);
      var hwRect = _hardwareEl.getBoundingClientRect();
      var stackRect = _stack.getBoundingClientRect();
      var connectorPxX = hwRect.width * hwAnchorX;
      var connectorPxY = hwRect.height * hwAnchorY;
      var hwLeftPx = hwRect.left - stackRect.left;
      var hwTopPx = hwRect.top - stackRect.top;
      var connectorAbsX = hwLeftPx + connectorPxX;
      var connectorAbsY = hwTopPx + connectorPxY;
      var holeAbsX = stackRect.width * (holeXPct / 100);
      var holeAbsY = stackRect.height * (holeYPct / 100);
      console.log('[ZUG][HW] === RENDERED POSITION DEBUG ===');
      console.log('[ZUG][HW]   stack: ' + stackRect.width.toFixed(1) + 'x' + stackRect.height.toFixed(1) + 'px');
      console.log('[ZUG][HW]   hardware box: ' + hwRect.width.toFixed(1) + 'x' + hwRect.height.toFixed(1) + 'px at (' + hwLeftPx.toFixed(1) + ',' + hwTopPx.toFixed(1) + ')');
      console.log('[ZUG][HW]   connector inside hw: (' + connectorPxX.toFixed(1) + ',' + connectorPxY.toFixed(1) + ')px');
      console.log('[ZUG][HW]   connector absolute: (' + connectorAbsX.toFixed(1) + ',' + connectorAbsY.toFixed(1) + ')px');
      console.log('[ZUG][HW]   acrylic hole absolute: (' + holeAbsX.toFixed(1) + ',' + holeAbsY.toFixed(1) + ')px');
      console.log('[ZUG][HW]   DELTA: dx=' + (connectorAbsX - holeAbsX).toFixed(1) + 'px dy=' + (connectorAbsY - holeAbsY).toFixed(1) + 'px');
    });
  }

  function init(previewContainer, options) {
    if (_active) destroy();
    options = options || {};
    _container = previewContainer;
    _currentOpts = options;
    _hasTab = false;
    _isKeychain = false;
    _buildStack(_container);
    _active = true;
    console.log('[ZUG][ACRYLIC_PREVIEW] init', { subtype: options.subtype });
  }

  function update(geoResult, previewUrl, options) {
    if (!_active || !_stack) return;
    options = options || _currentOpts;
    _currentOpts = options;

    _hasTab = !!geoResult.hasTab;
    _isKeychain = !!options.isKeychain;

    if (geoResult.outerMaskUri) {
      _stack.style.setProperty('--acr-outer-shape-svg', geoResult.outerMaskUri);
    }

    if (_hasTab) {
      _stack.classList.add('zug-acrylic-layer-stack--tabbed');
      if (geoResult.aspectRatio) {
        _stack.style.aspectRatio = geoResult.aspectRatio;
      }
      var stageScale = (options.stageScale != null) ? options.stageScale : 1;
      var stageOffsetY = (options.stageOffsetY != null) ? options.stageOffsetY : 0;
      if (stageScale !== 1 || stageOffsetY !== 0) {
        _stack.style.setProperty('--acr-stage-scale', String(stageScale));
        _stack.style.setProperty('--acr-stage-offset-y', stageOffsetY + '%');
        console.log('[ZUG][STAGE] framing: scale=' + stageScale + ' offsetY=' + stageOffsetY + '% (keychain=' + _isKeychain + ')');
      } else {
        _stack.style.removeProperty('--acr-stage-scale');
        _stack.style.removeProperty('--acr-stage-offset-y');
      }
    } else {
      _stack.classList.remove('zug-acrylic-layer-stack--tabbed');
      _stack.style.removeProperty('aspect-ratio');
      _stack.style.removeProperty('--acr-stage-scale');
      _stack.style.removeProperty('--acr-stage-offset-y');
    }

    if (geoResult.canvasRegion) {
      var region = _ensurePrintRegion();
      var cr = geoResult.canvasRegion;
      region.style.left = cr.left.toFixed(4) + '%';
      region.style.top = cr.top.toFixed(4) + '%';
      region.style.width = cr.width.toFixed(4) + '%';
      region.style.height = cr.height.toFixed(4) + '%';
      if (geoResult.printMaskBodyUri) {
        region.style.setProperty('--acr-print-shape-svg', geoResult.printMaskBodyUri);
      } else if (geoResult.printMaskUri) {
        region.style.setProperty('--acr-print-shape-svg', geoResult.printMaskUri);
      }
      _stack.style.setProperty('--acr-print-shape-svg', geoResult.printMaskUri || 'none');
      console.log('[ZUG][ACRYLIC_PREVIEW] === PRINT REGION WRAPPER (800→expanded viewBox) ===');
      console.log('[ZUG][ACRYLIC_PREVIEW]   canvasRegion: left=' + cr.left.toFixed(4) + '% top=' + cr.top.toFixed(4) + '% w=' + cr.width.toFixed(4) + '% h=' + cr.height.toFixed(4) + '%');
      console.log('[ZUG][ACRYLIC_PREVIEW]   presentationPaddingVB=' + (geoResult.presentationPaddingVB || 0).toFixed(2));
    } else {
      _removePrintRegion();
      if (geoResult.printMaskUri) {
        _stack.style.setProperty('--acr-print-shape-svg', geoResult.printMaskUri);
      }
    }

    var varMap = {
      edgeOffsetX: ['--acr-edge-offset-x', 'px'],
      edgeOffsetY: ['--acr-edge-offset-y', 'px'],
      frostOpacity: ['--acr-frost-opacity', ''],
      glossOpacity: ['--acr-gloss-opacity', ''],
      shineOpacity: ['--acr-shine-opacity', ''],
      shineWidth: ['--acr-shine-width', '%'],
      shineDuration: ['--acr-shine-duration', 's'],
      dropY: ['--acr-drop-y', 'px'],
      dropBlur: ['--acr-drop-blur', 'px'],
      dropOpacity: ['--acr-drop-opacity', '']
    };

    for (var key in varMap) {
      if (varMap.hasOwnProperty(key) && options[key] != null) {
        _stack.style.setProperty(varMap[key][0], String(options[key]) + varMap[key][1]);
      }
    }

    var _fillMode = options.fillMode || 'original';
    var _isOriginal = (_fillMode === 'original');

    var _isTransparentArt = !!options.isTransparentArt;

    if (options.bgColor && !_isTransparentArt) {
      _stack.style.setProperty('--acr-bg-color', options.bgColor);
      _stack.style.setProperty('--acr-border-color', options.bgColor);
      _layers.bgFill.style.visibility = 'visible';
      _layers.printBorder.style.visibility = 'visible';
      console.log('[ZUG][ACRYLIC_BG] solid fill applied: bgFill=' + options.bgColor + ' printBorder=' + options.bgColor);
    } else if (_isTransparentArt) {
      _stack.style.setProperty('--acr-bg-color', 'transparent');
      _stack.style.setProperty('--acr-border-color', 'transparent');
      _layers.bgFill.style.visibility = 'hidden';
      _layers.printBorder.style.visibility = 'hidden';
      console.log('[ZUG][ACRYLIC_TRANSPARENT] transparent art: bgFill HIDDEN, printBorder HIDDEN — clear acrylic around artwork');
    } else if (_isOriginal) {
      _stack.style.setProperty('--acr-bg-color', 'transparent');
      _stack.style.setProperty('--acr-border-color', 'transparent');
      _layers.bgFill.style.visibility = 'hidden';
      _layers.printBorder.style.visibility = 'hidden';
      console.log('[ZUG][ACRYLIC_BORDER] printBorder SUPPRESSED (original mode — render only the selected print-art source)');
    } else {
      _stack.style.setProperty('--acr-bg-color', 'transparent');
      _stack.style.setProperty('--acr-border-color', '#ffffff');
      _layers.bgFill.style.visibility = 'visible';
      _layers.printBorder.style.visibility = 'visible';
      console.log('[ZUG][ACRYLIC_BORDER] printBorder layer: white (default), masked to print shape');
    }
    console.log('[ZUG][ACRYLIC_BORDER] fillMode=' + _fillMode + ' isOriginal=' + _isOriginal + ' printBorderVisible=' + _layers.printBorder.style.visibility + ' borderColor=' + _stack.style.getPropertyValue('--acr-border-color'));
    console.log('[ZUG][ACRYLIC_BORDER] border source=shared-css-layer method=css-mask-print-shape');
    console.log('[ZUG][ACRYLIC_BORDER] clear acrylic gap preserved: printBorder uses print mask, not outer mask');

    var printLayer = _layers.print;
    var sourceCandidates = options.sourceCandidates && options.sourceCandidates.length
      ? options.sourceCandidates
      : _selectSourceCandidates({ preview: previewUrl });
    if (printLayer && sourceCandidates.length) {
      var img = printLayer.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.alt = 'Acrylic artwork';
        printLayer.appendChild(img);
      }
      _renderToken++;
      var myToken = _renderToken;
      console.log('[ZUG][ACRYLIC_PREVIEW] hasTab=' + _hasTab + ' printRegion=' + (!!_printRegion));
      console.log('[ZUG][ACRYLIC_SOURCE] candidate order:', sourceCandidates.map(function (candidate) {
        return candidate.kind;
      }));

      function renderCandidate(index) {
        if (myToken !== _renderToken) return;
        if (index >= sourceCandidates.length) {
          img.removeAttribute('src');
          img.style.visibility = 'hidden';
          console.error('[ZUG][ACRYLIC_SOURCE] FAIL CLOSED: no printable artwork source could be decoded or mapped');
          if (typeof options.onSourceFailure === 'function') {
            options.onSourceFailure();
          }
          return;
        }

        var candidate = sourceCandidates[index];
        _prepareSource(candidate, geoResult, function (error, prepared) {
          if (myToken !== _renderToken) return;
          if (error) {
            console.warn('[ZUG][ACRYLIC_SOURCE] rejected ' + candidate.kind + ': ' + error.message);
            renderCandidate(index + 1);
            return;
          }

          img.style.visibility = 'visible';
          img.onload = function () {
            if (myToken !== _renderToken) return;
            var rect = img.getBoundingClientRect();
            var diagnostics = prepared.diagnostics;
            console.log('[ZUG][ACRYLIC_SOURCE] === SOURCE MAPPING token=' + myToken + ' ===');
            console.log('[ZUG][ACRYLIC_SOURCE] source=' + diagnostics.kind + ' reason=' + diagnostics.selectionReason);
            console.log('[ZUG][ACRYLIC_SOURCE] canvas=' + diagnostics.canvasWidth + 'x' + diagnostics.canvasHeight + ' aligned=' + diagnostics.aligned + ' padded=' + diagnostics.padded + ' trustworthy=' + diagnostics.trustworthy);
            console.log('[ZUG][ACRYLIC_SOURCE] alphaBounds=', diagnostics.alphaBounds);
            console.log('[ZUG][ACRYLIC_SOURCE] mappedBounds=', diagnostics.mappedBounds);
            console.log('[ZUG][ACRYLIC_SOURCE] printBounds=', diagnostics.printBounds);
            console.log('[ZUG][ACRYLIC_SOURCE] outerBounds=', diagnostics.outerBounds);
            console.log('[ZUG][ACRYLIC_SOURCE] uniformScale=' + diagnostics.uniformScale + ' offset=(' + diagnostics.offsetX + ',' + diagnostics.offsetY + ')');
            console.log('[ZUG][ACRYLIC_PREVIEW] === RENDER VERIFY token=' + myToken + ' ===');
            console.log('[ZUG][ACRYLIC_PREVIEW] naturalSize: ' + img.naturalWidth + 'x' + img.naturalHeight);
            console.log('[ZUG][ACRYLIC_PREVIEW] renderedPx: ' + rect.width.toFixed(1) + 'x' + rect.height.toFixed(1));
            console.log('[ZUG][ACRYLIC_PREVIEW] printRegionWrapper: ' + (!!_printRegion));
            _renderSourceDiagnostics(geoResult, diagnostics);
          };
          img.onerror = function () {
            if (myToken !== _renderToken) return;
            console.warn('[ZUG][ACRYLIC_SOURCE] prepared image failed to render: ' + candidate.kind);
            renderCandidate(index + 1);
          };
          img.src = prepared.url;
        });
      }

      renderCandidate(0);
    }

    var outlineLayer = _layers.outline;
    if (outlineLayer) {
      outlineLayer.innerHTML = geoResult.outlineSvg || '';
    }

    var debugLayer = _layers.debug;
    if (debugLayer) {
      debugLayer.innerHTML = geoResult.debugOverlaySvg || '';
    }

    var _srcLabel = _stack.querySelector('.zug-acrylic-src-label');
    if (!_srcLabel) {
      _srcLabel = document.createElement('div');
      _srcLabel.className = 'zug-acrylic-src-label';
      _srcLabel.style.cssText = 'position:absolute;bottom:4px;left:4px;z-index:999;background:rgba(0,0,0,0.75);color:#0f0;font:bold 10px/1.25 monospace;padding:4px 6px;border-radius:3px;pointer-events:none;white-space:pre;';
      _stack.appendChild(_srcLabel);
    }
    _srcLabel.textContent = 'SRC: resolving';

    if (_isKeychain && options.hardwareConfig) {
      var _hwGeoData = null;
      if (geoResult.expandedViewBox && geoResult.bbox) {
        _hwGeoData = {
          evbWidth: geoResult.expandedViewBox.width,
          evbHeight: geoResult.expandedViewBox.height,
          bodyBboxWidth: geoResult.bbox.width,
          bodyBboxHeight: geoResult.bbox.height,
          physW: options.physW || 0,
          physH: options.physH || 0
        };
      }
      _applyHardware(options.hardwareConfig, geoResult.holeAnchor, _hwGeoData);
    } else {
      _removeHardware();
    }
    console.log('[ZUG][ACRYLIC_PREVIEW] update', { hasGeo: !geoResult.fallback, hasPreview: !!previewUrl, hasTab: _hasTab, isKeychain: _isKeychain });
  }

  function setEditingMode(editing) {
    if (!_stack) return;
    if (editing) {
      _stack.classList.add('zug-acrylic-layer-stack--editing');
    } else {
      _stack.classList.remove('zug-acrylic-layer-stack--editing');
    }
  }

  function destroy() {
    _renderToken++;
    _removeHardware();
    _removePrintRegion();
    if (_stack && _stack.parentNode) {
      _stack.parentNode.removeChild(_stack);
    }
    Object.keys(_sourceCache).forEach(function (key) {
      if (_sourceCache[key].owned && _sourceCache[key].url && _sourceCache[key].url.indexOf('blob:') === 0) {
        URL.revokeObjectURL(_sourceCache[key].url);
      }
    });
    _sourceCache = {};
    _stack = null;
    _layers = {};
    _container = null;
    _active = false;
    _hasTab = false;
    _isKeychain = false;
    _currentOpts = {};
    console.log('[ZUG][ACRYLIC_PREVIEW] destroyed');
  }

  function isActive() { return _active; }

  window.ZugAcrylicPreview = {
    init: init,
    update: update,
    destroy: destroy,
    isActive: isActive,
    setEditingMode: setEditingMode
  };

})();
